import {getToken} from '../adalConfig';

export const actionCreators = {

    // REQUEST_AUDITS
    requestAudits: () => async (dispatch, getState) => {       
        dispatch({ type: 'REQUEST_AUDITS' });
        const headers = { Authorization: `Bearer ${getToken()}` };
        const url = `api/Audits`;
        const response = await fetch(url, {headers});
        const audits = await response.json();
        dispatch({ type: 'RECEIVE_AUDITS', audits });
    }
};


// WEBPACK FOOTER //
// ./src/actions/audits.js